const statusLabels = {
  requested: 'Requested',
  accepted: 'Accepted',
  purchased: 'Purchased',
  in_transit: 'In transit',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
  disputed: 'Disputed',
};

const travelerActions = {
  requested: { label: 'Accept request', nextStatus: 'accepted' },
  accepted: { label: 'Mark purchased', nextStatus: 'purchased' },
  purchased: { label: 'Mark in transit', nextStatus: 'in_transit' },
  in_transit: { label: 'Mark delivered', nextStatus: 'delivered' },
};

export function orderStatusLabel(status) {
  return statusLabels[status] ?? String(status ?? '').replaceAll('_', ' ');
}

export function travelerOrderAction(status) {
  return travelerActions[status] ?? null;
}
